import { observer } from 'mobx-react-lite'
import {
  formatBookkeepingAccessMethod,
  formatBookkeepingManagerAction,
} from '@/features/admin/bookkeeping/bookkeeping-pending-action-formatters'

import { BookkeepingManagerDetails } from '@/features/admin/bookkeeping/components/BookkeepingManagerDetails'
import { DetailsContent } from './DetailsContent'
import { ProviderSection } from './ProviderSection'
import { DetailsFooter } from './DetailsFooter'
import { Member } from '@/features/iam/members/Member'
import { type BookkeepingManagerDetailsViewModel } from './BookkeepingManagerDetailsViewModel'
import { formatBookkeepingPlatformConnectionHelpText } from '@/features/jobs/bookkeeping/platform-connections/bookkeeping-platform-connection-formatters'

export interface BookkeepingManagerDetailsContainerProps {
  vm: BookkeepingManagerDetailsViewModel
}

export const BookkeepingManagerDetailsContainer = observer(
  function BookkeepingManagerDetailsContainer({
    vm,
  }: BookkeepingManagerDetailsContainerProps) {
    if (!vm.modal.showing) {
      return null
    }

    const action = vm.bookkeepingPendingAction
    const championPro = action.championPro

    return (
      <BookkeepingManagerDetails onClose={vm.modal.close}>
        <DetailsContent
          jobName={action.jobName}
          jobShortId={action.jobShortId}
          companyId={action.platformConnection?.displayId}
          companyName={action.platformConnection?.displayName}
          displayAccessMethod={formatBookkeepingAccessMethod(
            action.accessMethod,
          )}
          isConfirmAccess={action.action === 'ConfirmAccess'}
          displayAction={formatBookkeepingManagerAction(action.action)}
          datePendingSince={action.datePendingSince}
          helpText={
            action.platformConnection
              ? formatBookkeepingPlatformConnectionHelpText(
                  action.platformConnection,
                )
              : undefined
          }
        />
        {championPro !== Member.none && (
          <ProviderSection
            provider={{
              displayName: championPro.displayName,
              email: championPro.email,
              avatar: championPro.avatar,
              avatarFallback: championPro.avatarFallback,
            }}
          />
        )}
        <DetailsFooter
          showConfirmAccess={vm.showConfirmAccess}
          onConfirmAccess={vm.confirmAccess}
          isConfirmAccessPending={vm.confirmAccess.pending}
        />
      </BookkeepingManagerDetails>
    )
  },
)
